export default __webpack_public_path__ + "static/media/undraw_Walking_outside_re_56xo.c099516a.svg";